import { render } from "./TopHeader.vue?vue&type=template&id=43d4a49c&scoped=true"
const script = {}

import "./TopHeader.vue?vue&type=style&index=0&id=43d4a49c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-speech/democratielab-speech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d4a49c"]])

export default __exports__